import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP SystemError 화면 개발
 *
 ********************************************************************/
import "@static/css/content.css";
import { URL_MAIN } from "@utils/Const";
import { useText } from "@utils/langs/useTrans";
import { useNavigate } from "react-router-dom";
/**
 * @brief EHP SystemError 화면 컴포넌트
 * @param -
 * @returns react components
 */
function SystemError() {
    const t = useText();
    const navigate = useNavigate();
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ id: "wrap bg-white" }, { children: _jsx("main", Object.assign({ className: "container filereports" }, { children: _jsxs("div", Object.assign({ className: "area__error mb-16" }, { children: [_jsx("strong", { children: t("서비스점검") }), _jsx("p", { children: t("서비스점검문구") }), _jsxs("button", Object.assign({ type: "button", className: "btn-basic mt-40", onClick: () => navigate(URL_MAIN) }, { children: [_jsx("i", { className: "icon-go-large" }), _jsx("span", { children: t("메인으로가기") })] }))] })) })) })) }));
}
export default SystemError;
